import { gql } from "@outschool/ui-apollo";
import {
  ClassPostFragments,
  ClassPostMessageContentFragment
} from "@outschool/ui-components-classroom";

import ActivityStatusLabel from "../../components/ActivityStatusLabel";
import SectionManageToolbar from "../../components/nav/SectionManageToolbar";

export const SectionLessonPostFragmentGql = gql`
  fragment Section_LessonPostFragment on LessonPost {
    uid
    title
    lessonUid
    orderInLesson
    deleted_at
    is_posted_for_enrollments
    is_posted_for_subscriptions
    messageContent {
      ...ClassPost_messageContent
    }
  }
  ${ClassPostMessageContentFragment}
`;

const SectionAssignmentLessonPostFragmentGql = gql`
  fragment Section_AssignmentLessonPostFragment on AssignmentLessonPost {
    uid
    title
    lessonUid
    orderInLesson
    deleted_at
    submissionRequirement
    messageContent {
      ...ClassPost_messageContent
    }
  }
  ${ClassPostMessageContentFragment}
`;

export const SectionAssignmentClassPostFragmentGql = gql`
  fragment Section_AssignmentClassPost on AssignmentClassPost {
    uid
    title
    created_at
    deleted_at
    publishAt
    dueDate
    submissionRequirement
    messageContent {
      ...ClassPost_messageContent
    }
    lesson {
      uid
      title
    }
    lessonPost {
      ...Section_AssignmentLessonPostFragment
    }
  }
  ${ClassPostMessageContentFragment}
  ${SectionAssignmentLessonPostFragmentGql}
`;

const ClassPostLessonFragmentGql = gql`
  fragment ClassPost_Lesson on Lesson {
    uid
    title
    description
    week_number
    order_within_week
    lessonNumber
    unit {
      uid
      title
      unitNumber
    }
  }
`;
const SectionPostsLessonFragmentGql = gql`
  fragment SectionPosts_Lesson on Lesson {
    uid
    title
    description
    week_number
    order_within_week
    lessonNumber
    unlocksAt(sectionUid: $sectionUid)
    meetings(sectionUid: $sectionUid) {
      uid
      start_time
    }
    unit {
      uid
      title
      unitNumber
    }
    lessonPosts {
      ...Section_LessonPostFragment
    }
    classPosts(sectionUid: $sectionUid) {
      publishAt
      ...ClassPost_classPost
      lessonPost {
        ...Section_LessonPostFragment
      }
      lesson {
        ...ClassPost_Lesson
      }
    }
    assignmentClassPosts(sectionUid: $sectionUid) {
      ...Section_AssignmentClassPost
    }
    assignmentLessonPosts {
      ...Section_AssignmentLessonPostFragment
    }
  }
  ${SectionLessonPostFragmentGql}
  ${ClassPostFragments.classPost}
  ${ClassPostLessonFragmentGql}
  ${SectionAssignmentClassPostFragmentGql}
  ${SectionAssignmentLessonPostFragmentGql}
`;

export const sectionPostManagementQuery = gql`
  query SectionPostManagementQuery($sectionUid: ID!, $plainText: Boolean) {
    section(uid: $sectionUid) {
      ...SectionManageToolbar_section
      hasFrozenSyllabus
      syllabus {
        currentLesson(sectionUid: $sectionUid) {
          ...SectionPosts_Lesson
        }
        units {
          uid
          title
          unitNumber
        }
        lessons {
          ...SectionPosts_Lesson
        }
      }
      activity {
        uid
        title
        duration_weeks
        isSelfPaced
        isFlexSchedule
        ...ActivityStatusLabel_activity
        ...SectionManageToolbar_activity
      }
      sectionLessons {
        uid
        type
        title
        start_time
        lesson {
          ...SectionPosts_Lesson
        }
      }
    }
  }
  ${SectionPostsLessonFragmentGql}
  ${SectionManageToolbar.fragments.section}
  ${SectionManageToolbar.fragments.activity}
  ${ActivityStatusLabel.fragments.activity}
`;
